import { Component, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

export interface EstablishmentActivityFinessDuplicateWarningData {
  message: string;
}

@Component({
  selector: 'vex-establishment-activity-finess-duplicate-warning',
  templateUrl: './establishment-activity-finess-duplicate-warning.component.html',
})
export class EstablishmentActivityFinessDuplicateWarningComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: EstablishmentActivityFinessDuplicateWarningData,
    private dialogRef: MatDialogRef<EstablishmentActivityFinessDuplicateWarningComponent, boolean>,
  ) {}

  confirm(): void {
    this.dialogRef.close(true);
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
